import type { WeaponSpec } from '@/content/weapons';

export function impactDamage(spec: WeaponSpec, approachSpeed: number, reducedMass: number): number {
  const capped = Math.min(approachSpeed, spec.maxSpeed);
  const over = capped - spec.minSpeed;
  if (over <= 0) return 0;
  const span = Math.max(0.001, spec.refSpeed - spec.minSpeed);
  const shaped = Math.pow(over / span, spec.damageExponent);
  return shaped * spec.damageCoefficient * (reducedMass / spec.headMass);
}

export function reducedMass(massA: number, massB: number): number {
  if (massB <= 0 || !Number.isFinite(massB)) return massA;
  return (massA * massB) / (massA + massB);
}
